export async function getPlatformInfo(): Promise<chrome.runtime.PlatformInfo | null> {
  try {
    return await chrome.runtime.getPlatformInfo();
  } catch (error) {
    return null;
  }
}
